<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"
        ><i class="fas fa-edit"></i>&nbsp;Edit</b-button
      >
    </slot>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="!this.create" label="_ID" label-for="id-input">
          <b-form-input
            id="id-input"
            v-model="formValues.id"
            :state="null"
            autocomplete="off"
            required
            disabled
          />
        </b-form-group>
        <b-form-group v-if="!this.create" label="UID" label-for="uid-input">
          <b-form-input
            id="uid-input"
            v-model="formValues.uid"
            :state="null"
            autocomplete="off"
            required
            disabled
          />
        </b-form-group>
        <b-form-group label="Name" label-for="name-input">
          <b-form-input
            id="name-input"
            name="name-input"
            v-model="formValues.name"
            v-validate="{ required: true, min: 4, max: 25 }"
            :state="validateState('name-input')"
            aria-describedby="name-input-live-feedback"
            data-vv-as="Name"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="name-input-live-feedback">
            {{ veeErrors.first('name-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Nick Name" label-for="shortName-input">
          <b-form-input
            id="shortName-input"
            name="shortName-input"
            v-model="formValues.shortName"
            v-validate="{ required: false, max: 15 }"
            :state="validateState('shortName-input')"
            aria-describedby="shortName-input-live-feedback"
            data-vv-as="Shortname"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="shortName-input-live-feedback">
            {{ veeErrors.first('shortName-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Barcode" label-for="barcode-input">
          <b-form-input
            id="barcode-input"
            name="barcode-input"
            placeholder="0-*"
            v-model="formValues.authCode"
            v-validate="{ required: false, min: 4, max: 10 }"
            :state="validateState('barcode-input')"
            aria-describedby="barcode-input-live-feedback"
            data-vv-as="Barcode"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="barcode-input-live-feedback">
            {{ veeErrors.first('barcode-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Password" label-for="password-input">
          <b-form-input
            id="password-input"
            name="password-input"
            v-model="formValues.password"
            v-validate="{ required: true, min: 4, max: 10 }"
            :state="validateState('password-input')"
            aria-describedby="password-input-live-feedback"
            data-vv-as="Password"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="password-input-live-feedback">
            {{ veeErrors.first('password-input') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="formValues.manager"
            :value="1"
            @change="switchManagerViewer('manager')"
            >Dealer</b-form-checkbox
          >
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="formValues.viewer"
            :value="1"
            @change="switchManagerViewer('viewer')"
            >Viewer</b-form-checkbox
          >
        </b-form-group>

        <b-form-group label="Photo" label-for="photo-input">
          <div v-if="formValues.photo" class="mb-2" style="max-width: 200px">
            <div class="position-relative">
              <b-img :src="formValues.photo" fluid alt="Dealer photo"></b-img>
              <b-button
                variant="danger"
                size="sm"
                class="position-absolute"
                style="top: 5px; right: 5px;"
                @click="removePhoto"
              >
                <i class="fas fa-times"></i>
              </b-button>
            </div>
          </div>
          <b-form-file
            id="photo-input"
            ref="photoInput"
            accept="image/*"
            placeholder="Choose a photo..."
            @change="handlePhotoChange"
          />
        </b-form-group>

        <b-form-group
          label="Tables"
          label-for="tables-input"
          v-if="!formValues.alltables"
        >
          <small
            v-if="create && hasTableRestrictions && chosenTables.length > 0"
            class="text-muted d-block mb-2"
          >
            <i class="fas fa-info-circle"></i> All available tables are selected
            by default
          </small>
          <multiselect
            id="filter-type"
            v-model="chosenTables"
            :options="tablesOptions"
            :custom-label="opt => opt.value"
            track-by="value"
            :multiple="true"
            :placeholder="$t('Select')"
            :select-label="$t('Press enter to select')"
            :selected-label="$t('Selected')"
            :loading="!this.$store.getters['tablesForSelect/loaded']"
            :disabled="!this.$store.getters['tablesForSelect/loaded']"
            :hide-selected="true"
          />
        </b-form-group>
      </form>

      <b-button
        class="mt-2 float-right"
        variant="primary"
        @click="handleSubmit"
        :disabled="
          !this.$store.getters['tablesForSelect/loaded'] ||
            (formValues.viewer !== 1 && formValues.manager !== 1)
        "
        >Save</b-button
      >
    </b-modal>
  </span>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VJsoneditor from 'v-jsoneditor/src/index'
import Vue from 'vue'

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
      chosenTables: [],
      cdnEngineUrl: process.env.VUE_APP_CDN_BACK_URL
    }
  },
  components: {
    Multiselect,
    VJsoneditor
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    switchManagerViewer(select) {
      if (select === 'manager') {
        this.formValues.viewer = 0
      } else {
        this.formValues.manager = 0
      }
    },
    getInitialValues() {
      return {
        id: null,
        name: null,
        shortName: null,
        password: null,
        manager: 0,
        viewer: 0,
        alltables: false,
        multichat: false,
        tables: [],
        photo: null,
        photoFile: null
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    resetModal() {
      this.setDefaults()
    },
    hideModal() {
      this.$refs['modal-container'].hide()
    },
    toggle() {
      this.modalShow = !this.modalShow
    },
    async handlePhotoChange(event) {
      const file = event.target.files[0]
      if (!file) {
        this.formValues.photo = null
        return
      }

      const formData = new FormData()
      formData.append('file', file)

      try {
        const response = await this.$http.post(
          '/api/v1/dealers/upload-photo',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )

        this.formValues.photo = this.cdnEngineUrl + response.data.url
      } catch (error) {
        this.$toastr.e('Failed to upload photo')
        this.$refs.photoInput.$refs.input.value = ''
      }
    },
    removePhoto() {
      this.formValues.photo = null
      this.$refs.photoInput.$refs.input.value = ''
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }

        if (this.formValues.alltables) {
          this.chosenTables = []
        }

        const data = {
          ...this.formValues,
          tables: this.chosenTables.map(opt => opt.value)
        }

        // Remove photoFile from request data as it's not needed on backend
        delete data.photoFile

        this.$http({
          url: this.create
            ? '/api/v1/dealers'
            : '/api/v1/dealers/' + this.formValues.id,
          data: data,
          method: this.create ? 'POST' : 'PUT',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish')
            }, 500)

            this.hideModal()
            this.$toastr.i('Success')
          })
          .catch(err => {
            this.$toastr.e(JSON.stringify(err.response.data.message))

            throw err
          })
      })
    },
    setFormValues(values) {
      for (let field in values) {
        Vue.set(this.formValues, field, values[field])
      }
    },
    setDefaults() {
      this.setFormValues(this.getInitialValues())

      this.setFormValues({ ...this.defaultValues })

      // Автоматически назначаем все доступные столы только если:
      // 1. Создаем нового дилера
      // 2. У пользователя есть ограничения по столам (не админ и есть столы)
      const currentUser = this.$store.getters.currentUser
      const hasTableRestrictions =
        currentUser &&
        currentUser.type !== 1 &&
        currentUser.tables &&
        currentUser.tables.length > 0

      if (
        this.create &&
        hasTableRestrictions &&
        (!this.formValues.tables || this.formValues.tables.length === 0)
      ) {
        this.chosenTables = this.tablesOptions
      } else {
        this.chosenTables = (this.formValues.tables || []).map(value => {
          return {
            label: value,
            value: value
          }
        })
      }
    }
  },
  computed: {
    tablesOptions() {
      const allTables = (this.$store.getters['tablesForSelect/list'] || []).map(
        t => {
          const value = Number.parseInt(t.value)
          return { value: value, label: value }
        }
      )

      // Получаем текущего пользователя
      const currentUser = this.$store.getters.currentUser

      // Если пользователь не загружен или это админ (type === 1), показываем все столы
      if (!currentUser || currentUser.type === 1) {
        return allTables
      }

      // Если у пользователя есть ограничения по столам
      const userTables = currentUser.tables || []

      // Если массив столов пустой, не показываем ничего
      if (userTables.length === 0) {
        return []
      }

      // Фильтруем столы по доступным для пользователя
      return allTables.filter(table => userTables.includes(table.value))
    },
    hasTableRestrictions() {
      const currentUser = this.$store.getters.currentUser
      return (
        currentUser &&
        currentUser.type !== 1 &&
        currentUser.tables &&
        currentUser.tables.length > 0
      )
    }
  },
  async beforeMount() {
    // Загружаем текущего пользователя и список столов
    await Promise.all([
      this.$store.dispatch('loadCurrentUser'),
      this.$store.dispatch('tablesForSelect/loadList')
    ])
  },
  mounted() {
    this.setDefaults()
  }
}
</script>
